import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core';
import axios from 'axios';

const localizer = momentLocalizer(moment);

const Timeclock = ({ siteCode, initialSiteQuery, preloadedPunches }) => {
  console.log("Timeclock received preloadedPunches:", preloadedPunches);
  // Helper functions for localStorage
  const getStoredDate = () => {
    try {
      const stored = localStorage.getItem('calendar-date');
      return stored ? new Date(stored) : new Date();
    } catch (error) {
      console.error('Error reading date from localStorage:', error);
      return new Date();
    }
  };

  const getStoredView = () => {
    try {
      const stored = localStorage.getItem('calendar-view');
      return stored || 'month';
    } catch (error) {
      console.error('Error reading view from localStorage:', error);
      return 'month';
    }
  }; 


  const [currentDate, setCurrentDate] = useState(getStoredDate);
  const [currentView, setCurrentView] = useState(getStoredView);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [openDetailsModal, setOpenDetailsModal] = useState(false); 

useEffect(() => {
  setLoading(true);
  if (preloadedPunches) {
    const fetchedEvents = preloadedPunches.map(job => ({
      title: job.jobType + ": " + job.staff,       
      jobType: job.jobType,
      start: new Date(job.startTime * 1000),
      end: new Date((job.startTime * 1000) + 3600000),
      shiftId: job.shiftId,
      description: job.timeDescription,           
      staff: job.staff
    }));
    setEvents(fetchedEvents);
    setLoading(false);
  } else if (siteCode) {
    //fetchEvents(siteCode);
  }
}, [siteCode, preloadedPunches]);

  const fetchEvents = useCallback(async (code) => {
    try {
      setLoading(true);
      var urlTarget;
      if (initialSiteQuery) {
        urlTarget = `https://api.precisiononcall.com:8088/api/?q=${code}&s=${encodeURIComponent(initialSiteQuery.replace(/['"]+/g, ''))}`;
      } else {
        urlTarget = `https://api.precisiononcall.com:8088/api/?q=${code}`;
      }      
      const response = await axios.get(urlTarget);
      if (response.status === 200 && response.data.punches) {
        const fetchedEvents = response.data.punches.map(punch => ({
          title: (punch.jobType + ": " + punch.staff),
          start: new Date(punch.startTime * 1000),
          end: new Date((punch.startTime * 1000) + 3600),
          allDay: true,
          staff: punch.staff,
          jobType: punch.jobType,
          description: punch.timeDescription
        }));
        setEvents(fetchedEvents);
      } else {
        console.error('Failed to fetch punches or no punches returned');
      }
    } catch (error) {
      console.error('Error fetching punches:', error);
    } finally {
      setLoading(false);
    }
  }, [initialSiteQuery]);
/*
  useEffect(() => {
    if (siteCode) {
      fetchEvents(siteCode);
    }
  }, [siteCode, fetchEvents]);
  */

  useEffect(() => {
    const storedDate = getStoredDate();
    const storedView = getStoredView();
    
    setCurrentDate(storedDate);
    setCurrentView(storedView);
  }, []);    

  const handleEventSelect = (event) => {
    setSelectedEvent(event);
    setOpenDetailsModal(true);
  };

  const handleCloseModal = () => {
    setOpenDetailsModal(false);
  };

  if (loading) {
    return <CircularProgress />;
  }

  const handleNavigate = (date) => {
    setCurrentDate(date);
    try {
      localStorage.setItem('calendar-date', date.toISOString());
    } catch (error) {
      console.error('Error saving date to localStorage:', error);
    }
  };
  const handleViewChange = (view) => {
    setCurrentView(view);
    try {
      localStorage.setItem('calendar-view', view);
    } catch (error) {
      console.error('Error saving view to localStorage:', error);
    }
  };     

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        onNavigate={handleNavigate}
        onView={handleViewChange}         
        style={{ height: '100vh' }}
        views={['week', 'month', 'day', 'agenda']}
        date={currentDate}
        view={currentView} 
        onSelectEvent={handleEventSelect}
        min={moment().subtract(3, 'months').toDate()}
        max={moment().endOf('month').toDate()}
      />
      <Dialog open={openDetailsModal} onClose={handleCloseModal}>
        <DialogTitle>Punch Details</DialogTitle>
        <DialogContent>
          {selectedEvent && (
            <>
              <p><strong>Assigned Staff:</strong> {selectedEvent.staff}</p>
              <p><strong>Start Time:</strong> {moment(selectedEvent.start).format('MMMM D, YYYY HH:mm')}</p>
              <p><strong>Description:</strong> {selectedEvent.description}</p>
              <p><strong>Job Type:</strong> {selectedEvent.jobType}</p>
              <p style={{ textAlign: 'center', marginTop: '20px' }}>
                Times listed are estimates and subject to adjustment
              </p>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Timeclock;